/**
 * @generated SignedSource<<b3bb91e11a9104f415362131338d76da>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type BaseProjectVersionApprovalButtonFragment$data = {
  readonly approval: {
    readonly __typename: "ProjectVersionApproval";
    readonly accept: boolean;
    readonly id: string;
    readonly notes: string | null | undefined;
    readonly scores: ReadonlyArray<{
      readonly competitionScoringCriterion: {
        readonly id: string;
      };
      readonly id: string;
      readonly value: number | null | undefined;
    }>;
  } | null | undefined;
  readonly entity: {
    readonly displayName: string;
    readonly username: string;
  };
  readonly id: string;
  readonly project: {
    readonly id: string;
    readonly stage: {
      readonly id: string;
      readonly scoringCriteria: ReadonlyArray<{
        readonly description: string | null | undefined;
        readonly id: string;
        readonly title: string;
      }>;
    };
  };
  readonly version: Semver;
  readonly viewerCanApprove: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"SubmissionStatusBadgeFragment">;
  readonly " $fragmentType": "BaseProjectVersionApprovalButtonFragment";
};
export type BaseProjectVersionApprovalButtonFragment$key = {
  readonly " $data"?: BaseProjectVersionApprovalButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BaseProjectVersionApprovalButtonFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BaseProjectVersionApprovalButtonFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectVersionApproval",
      "kind": "LinkedField",
      "name": "approval",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accept",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectVersionApprovalScore",
          "kind": "LinkedField",
          "name": "scores",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CompetitionScoringCriterion",
              "kind": "LinkedField",
              "name": "competitionScoringCriterion",
              "plural": false,
              "selections": [
                (v0/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionStage",
          "kind": "LinkedField",
          "name": "stage",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "CompetitionScoringCriterion",
              "kind": "LinkedField",
              "name": "scoringCriteria",
              "plural": true,
              "selections": [
                (v0/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "viewerCanApprove",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_PROJECT_VERSION_APPROVAL"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_PROJECT_VERSION_APPROVAL\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubmissionStatusBadgeFragment"
    }
  ],
  "type": "ProjectVersion",
  "abstractKey": null
};
})();

(node as any).hash = "9b87aa326b1d982657d1e52df5b0b214";

export default node;
